<template>
  <v-card v-if="!declineMode">
    <v-card-title style="background-color: #004056" class="white--text">
      Open this Lead?
    </v-card-title>

    <v-divider />

    <v-card-text class="mt-4">
      <slot />
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-center py-3 px-6">
      <v-btn @click="$emit('close')">Back</v-btn>
      <v-btn @click="declineMode = true">Decline</v-btn>
      <v-btn class="ml-auto" color="primary" @click="$emit('open')">
        <slot name='openLabel'>Open</slot>
      </v-btn>
    </v-card-actions>
  </v-card>

  <DeclineLeadCard v-else :lead="lead" @back="declineMode=false" />
</template>

<script>
import DeclineLeadCard from './DeclineLeadCard.vue'

export default {
  name: 'UnopenedLeadCard',

  components: { DeclineLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    declineMode: false,
  }),
}
</script>